"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var bind_1 = require("../../../bind");
var PriceFilters = /** @class */ (function (_super) {
    tslib_1.__extends(PriceFilters, _super);
    function PriceFilters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceFilters.prototype.togglePriceFilters = function (e) {
        var filterByPrice = e.target.checked;
        this.props.onUpdate({ filterByPrice: filterByPrice });
    };
    PriceFilters.prototype.handlePriceMinChange = function (e) {
        var priceMin = e.target.value;
        this.props.onUpdate({ priceMin: priceMin });
    };
    PriceFilters.prototype.handlePriceMaxChange = function (e) {
        var priceMax = e.target.value;
        this.props.onUpdate({ priceMax: priceMax });
    };
    PriceFilters.prototype.renderPriceFilters = function () {
        if (!this.props.filterByPrice) {
            return null;
        }
        return (React.createElement("div", { className: "feed-modal__switch__inputs" },
            React.createElement("label", { htmlFor: "price-min" }, I18n.t('discovery.addFollowToFeed.priceMinLabel')),
            React.createElement("input", { name: "price-min", id: "price-min", onChange: this.handlePriceMinChange, value: this.props.priceMin || '', type: "text" }),
            React.createElement("label", { htmlFor: "price-max" }, I18n.t('discovery.addFollowToFeed.priceMaxLabel')),
            React.createElement("input", { name: "price-max", id: "price-max", onChange: this.handlePriceMaxChange, value: this.props.priceMax || '', type: "text" })));
    };
    PriceFilters.prototype.render = function () {
        return (React.createElement("div", { className: "feed-modal__option" },
            React.createElement("div", { className: "feed-modal__switch" },
                React.createElement("input", { type: "checkbox", id: "price-filter-toggle", onChange: this.togglePriceFilters, checked: this.props.filterByPrice }),
                React.createElement("label", { htmlFor: "price-filter-toggle" }, I18n.t('discovery.addFollowToFeed.filterByPrice'))),
            React.createElement("form", null, this.renderPriceFilters())));
    };
    tslib_1.__decorate([
        bind_1.default
    ], PriceFilters.prototype, "togglePriceFilters", null);
    tslib_1.__decorate([
        bind_1.default
    ], PriceFilters.prototype, "handlePriceMinChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], PriceFilters.prototype, "handlePriceMaxChange", null);
    return PriceFilters;
}(React.Component));
exports.default = PriceFilters;
//# sourceMappingURL=price_filters.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/price_filters.js
// module id = UF0O
// module chunks = 20 21